import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function ConfirmationModal({ callBack, open, setOpen, text, headerText, confirmButtonText, destructive = false }) {
  // Handle modal close
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      data-cy="confirmationModal"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: 'min(92vw, 480px)',
          borderRadius: 1,
          boxShadow: '0 18px 48px rgba(0, 0, 0, 0.24)',
        },
      }}
    >
      <DialogTitle
        sx={{
          px: 3,
          pt: 3,
          pb: 1,
          fontWeight: 700,
          lineHeight: 1.25,
        }}
      >
        {headerText}
      </DialogTitle>
      <DialogContent sx={{ px: 3, py: 1 }}>
        <Typography
          variant="body1"
          sx={{
            color: (theme) => theme.palette.text.secondary,
            lineHeight: 1.6,
          }}
        >
          {text}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pt: 2,
          pb: 3,
          gap: 1,
          flexWrap: 'wrap',
        }}
      >
        <Button data-cy="button-cancel-confirmationModal" variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          sx={
            destructive
              ? {
                  backgroundColor: (theme) => theme.palette.toneNegative.main,
                  color: (theme) => theme.palette.whiteScaleLighter.main,
                  '&:hover': {
                    backgroundColor: (theme) => theme.palette.toneNegative.main,
                    filter: 'brightness(0.92)',
                  },
                }
              : undefined
          }
          onClick={() => {
            handleClose();
            callBack();
          }}
          variant="contained"
          color={destructive ? undefined : 'primary'}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationModal;
